var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path1",
    d: "M610.332 512l393.322-393.326c27.152-27.152 27.152-71.17 0-98.318-27.148-27.152-71.17-27.152-98.321 0l-393.322 393.322-393.322-393.326c-27.152-27.152-71.17-27.152-98.318 0l-0.007 0.004c-27.152 27.152-27.152 71.17 0 98.321l393.326 393.322-393.326 393.322c-27.152 27.152-27.152 71.17 0 98.321l0.004 0.004c27.152 27.148 71.17 27.148 98.318 0l393.322-393.326 393.326 393.322c27.152 27.152 71.17 27.152 98.321 0 27.148-27.152 27.148-71.17 0-98.318l-393.322-393.326z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4cf4a88ed749cbd4170615d2d2f2beb8.svg";
export { ForwardRef as ReactComponent };